<script setup lang="ts">
import { ref, computed, reactive, onMounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
import { useI18n } from "vue-i18n";
import { countries } from "./../../utils/countries";
import { ElMessage } from "element-plus";
import axios from "./../../utils/axios";
import AMapLoader from "@amap/amap-jsapi-loader";

// 存储当前使用的高德地图API引用
const AMapAPI = ref(null);

const activeCompany = ref(1); // 添加当前激活的公司状态

const switchCompany = (index: number) => {
  activeCompany.value = index;
  if (index === 1) {
    initMap();
  }
};
onMounted(() => {
  if (activeCompany.value === 1) {
    initMap();
  }
});
// 使用 Vue 的 Composition API
const router = useRouter();
const email = "zhangzhengyi@gylianhe.com";
const hemail = "muc4616@gmail.com";
const replacementImg = ref<HTMLElement | null>(null);
const replacementImg2 = ref<HTMLElement | null>(null);
const replacementImg3 = ref<HTMLElement | null>(null);
const replacementImg4 = ref<HTMLElement | null>(null);
const replacementImg5 = ref<HTMLElement | null>(null);
const replacementImg6 = ref<HTMLElement | null>(null);
const mapInstance = ref(null);
const markerInstance = ref(null);
const { t, locale } = useI18n(); // 移动到这里

// 定义三个函数，处理点击事件，跳转到 Facebook，Instagram，YouTube 个人资料页面
const handleClick1 = () => {
  window.location.href =
    "https://www.facebook.com/profile.php?id=61558820642464&is_tour_completed";
};

const handleClick2 = () => {
  window.location.href = "https://www.instagram.com/tantivyvikadpa";
};

const handleClick3 = () => {
  window.location.href =
    "https://www.youtube.com/channel/UCTh-j33XNnuY-LYv4RBfXvg";
};

// 获取 el-form 节点
const formRef = ref();
// 表单数据
const form = reactive({
  name: "",
  company: "",
  country: "",
  city: "",
  address: "",
  mobile: "",
  email: "", // 新增
  type: "",
  source: [],
  password: "",
  confirmPassword: "",
  description: "",
  countryCode: "",
  // code: ""
});
// 存储选中的业务类型
const selectedType = ref("");
const selectedSource = ref([]);
const countryOptions = computed(() =>
  countries.map((country) => ({
    value: country.code,
    label: `${locale.value === "zh-cn" ? country.zh : country.en} (${
      country.countryCode
    })`,
    code: country.countryCode,
  }))
);
// 表单验证规则
const rules = reactive({
  name: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.name.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.name.required"),
      trigger: "blur",
    },
    {
      min: 2,
      max: 15,
      message: t("system.contact.register.rules.name.length"),
      trigger: "blur",
    },
  ],
  company: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.company.pattern"),
      trigger: "blur",
    },
    // {
    //   required: true,
    //   message: t("system.contact.register.rules.company.required"),
    //   trigger: "blur"
    // },
    {
      min: 3,
      max: 15,
      message: t("system.contact.register.rules.company.length"),
      trigger: "blur",
    },
  ],
  mobile: [
    {
      pattern: /^[0-9]{1,4}[-\s]?(?:[0-9]{2,4}[-\s]?){1,3}[0-9]{2,4}$/,
      message: t("system.contact.register.rules.mobile.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.mobile.required"),
      trigger: "blur",
    },
  ],
  email: [
    {
      pattern:
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
      message: t("system.contact.register.rules.email.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.email.required"),
      trigger: "blur",
    },
  ],
  country: [
    {
      required: true,
      message: t("system.contact.register.rules.country.required"),
      trigger: "blur",
    },
  ],
  /*
  password: [
    {
      required: true,
      message: t("system.contact.register.rules.password.required"),
      trigger: "blur",
    },
    {
      pattern:
        /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/,
      message: t("system.contact.register.rules.password.pattern"),
      trigger: "blur",
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: t("system.contact.register.rules.confirmpassword.required"),
      trigger: "blur",
    },
    {
      validator: (
        _rules: any,
        value: string,
        callback: (arg0: Error | undefined) => void
      ) => {
        if (value !== form.password) {
          callback(new Error("确认密码与密码不匹配"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  */
  description: [
    {
      required: true,
      message: t("system.contact.register.rules.description.required"),
      trigger: "blur",
    },
  ],
});
const phonePrefix = ref(countries[0].countryCode);
// 修改 handleCountryChange 函数
const handleCountryChange = (value: string) => {
  const country = countries.find((c) => c.code === value);
  if (country) {
    phonePrefix.value = country.countryCode;
    // 根据语言环境选择要传输的国家名称
    form.country = locale.value === "zh-cn" ? country.zh : country.en;
    form.countryCode = country.countryCode;
  }
};
const onSubmit = () => {
  // 执行表单验证
  formRef.value.validate((valid: any) => {
    if (valid) {
      // 表单验证通过，可以提交表单数据
      form.type = selectedType.value;
      form.source = selectedSource.value;
      axios
        .post("/register", form)
        .then((response) => {
          ElMessage.success("提交成功");
          // 清空表单
          Object.keys(form).forEach((key) => {
            form[key] = "";
          });
          selectedType.value = "";
          selectedSource.value = [];
          // 重置表单校验状态
          formRef.value.resetFields();
        })
        .catch((error) => {
          console.error("注册失败:", error);
        });
    }
  });
};

const initMap = () => {
  nextTick(() => {
    // 如果地图实例存在，检查是否只需要更新语言
    if (mapInstance.value && AMapAPI.value) {
      // 更新地图语言
      mapInstance.value.setLang(locale.value === "zh-cn" ? "zh_cn" : "en");

      // 更新标记点内容
      if (markerInstance.value) {
        markerInstance.value.setTitle(
          locale.value === "zh-cn"
            ? "上海晓隆科技有限公司"
            : "Xiaolong Technology Co., Ltd.Shanghai"
        );

        markerInstance.value.setLabel({
          content:
            locale.value === "zh-cn"
              ? "上海晓隆科技有限公司"
              : "Xiaolong Technology",
          direction: "top",
          offset: new AMapAPI.value.Pixel(0, -10),
        });
      }

      return; // 更新完成，不需要重新创建地图
    }

    // 初始化地图（只在第一次加载或地图被销毁后执行）
    window._AMapSecurityConfig = {
      securityJsCode: "975c86d41f80251d7f3c0590609ace55",
    };

    AMapLoader.load({
      key: "4cbaab91ab2940c8b6e4c2c94d644b4e",
      version: locale.value === "zh-cn" ? "2.0" : "1.4.15",
      plugins: ["AMap.ToolBar", "AMap.Scale"],
    })
      .then((AMap) => {
        // 保存AMap API引用
        AMapAPI.value = AMap;

        const map = new AMap.Map("map-container", {
          zoom: 18,
          center: [121.225799, 31.294913],
          pitch: 50,
          lang: locale.value === "zh-cn" ? "zh_cn" : "en", // 初始语言设置
        });

        map.plugin(["AMap.ToolBar", "AMap.Scale"], function () {
          map.addControl(new AMap.ToolBar());
          map.addControl(new AMap.Scale());
        });

        const marker = new AMap.Marker({
          position: [121.225799, 31.294913],
          title:
            locale.value === "zh-cn"
              ? "上海晓隆科技有限公司"
              : "Xiaolong Technology Co., Ltd.Shanghai",
          label: {
            content:
              locale.value === "zh-cn"
                ? "上海晓隆科技有限公司"
                : "Xiaolong Technology",
            direction: "top",
            offset: new AMap.Pixel(0, -10),
          },
          autoRotation: true,
          animation: "AMAP_ANIMATION_BOUNCE",
        });

        map.add(marker);
        mapInstance.value = map;
        markerInstance.value = marker;
      })
      .catch((e) => {
        console.error("地图加载失败：", e);
      });
  });
};

// 监听语言变化时只更新地图语言，不重新创建地图
watch(locale, () => {
  if (activeCompany.value === 1) {
    initMap();
  }
});
</script>

<template>
  <div class="contactway">
    <div class="kong">
      <Header> </Header>
    </div>
    <div class="box">
      <div class="image_box">
        <img src="./../../../public/lianxi.png" alt="" />
      </div>
    </div>
    <div class="main">
      <div class="title">
        <div class="title_li">
          <div class="title_lis">
            <a class="no" href="/">{{ $t("system.contact.register.s_y") }}</a>
            <text>></text>
            <a class="th">{{ $t("system.home.lianjie.a_q") }}</a>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="content_box">
          <div class="contact-container">
            <!-- 左侧消息表单 -->
            <div class="message-section">
              <h3>{{ $t("system.contact.register.title") }}</h3>
              <p class="message-intro">
                {{ $t("system.contact.register.intro") }}
              </p>
              <el-form
                :model="form"
                ref="formRef"
                :rules="rules"
                label-width="auto"
                class="contact-form"
              >
                <el-form-item
                  style="font-size: 18px"
                  :label="$t('system.contact.register.name')"
                  prop="name"
                  required
                >
                  <el-input v-model="form.name" />
                </el-form-item>
                <el-form-item
                  :label="$t('system.contact.register.country')"
                  prop="country"
                  required
                >
                  <el-select
                    v-model="form.country"
                    @change="handleCountryChange"
                  >
                    <el-option
                      v-for="item in countryOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item
                  :label="$t('system.contact.register.mobile')"
                  prop="mobile"
                  required
                >
                  <el-input v-model="form.mobile">
                    <template #prepend>
                      <span>{{ phonePrefix }}</span>
                    </template>
                  </el-input>
                </el-form-item>

                <el-form-item
                  :label="$t('system.contact.register.email')"
                  prop="email"
                  required
                >
                  <el-input v-model="form.email" />
                </el-form-item>

                <el-form-item
                  :label="$t('system.contact.register.description')"
                  required
                  prop="description"
                >
                  <el-input
                    :autosize="{ minRows: 5 }"
                    type="textarea"
                    v-model="form.description"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="submit-btn"
                    type="primary"
                    @click="onSubmit"
                    >{{ $t("system.contact.register.primary") }}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>

            <!-- 右侧联系信息 -->
            <div class="contact-info">
              <div class="company-switch">
                <span
                  :class="{ active: activeCompany === 1 }"
                  @click="switchCompany(1)"
                >
                  {{ $t("system.contact.contactWay.g_s") }}
                </span>
                <!-- <span
                  :class="{ active: activeCompany === 2 }"
                  @click="switchCompany(2)"
                >
                  {{ $t("system.contact.contactWay.hg_s") }}
                </span> -->
              </div>

              <div v-show="activeCompany === 1" class="company-content">
                <div class="info-list">
                  <div class="info-item">
                    <i class="el-icon-location"></i>
                    <span>{{ $t("system.contact.contactWay.dizhi") }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-phone"></i>
                    <span>{{ $t("system.contact.contactWay.phone") }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-message"></i>
                    <span>{{
                      $t("system.contact.contactWay.email", { email })
                    }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-message"></i>
                    <span>{{ $t("system.contact.contactWay.youbian") }}</span>
                  </div>
                </div>

                <div class="map-container">
                  <div id="map-container" class="map-frame"></div>
                </div>
              </div>

              <!-- <div v-show="activeCompany === 2" class="company-content">
                <div class="info-list">
                  <div class="info-item">
                    <i class="el-icon-location"></i>
                    <span>{{ $t("system.contact.contactWay.hdizhi") }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-phone"></i>
                    <span>{{ $t("system.contact.contactWay.hphone") }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-message"></i>
                    <span>{{
                      $t("system.contact.contactWay.hemail", { hemail })
                    }}</span>
                  </div>
                  <div class="info-item">
                    <i class="el-icon-message"></i>
                    <span>{{ $t("system.contact.contactWay.hyoubian") }}</span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>
<style lang="scss" scoped>
.kong {
  max-width: 1200px;
  height: 120px;
}
.box {
  position: relative;
}
.image_box {
  padding-top: 18.23%;
  min-height: inherit;
  height: 200px;
  display: block;
  position: relative;
  overflow: hidden;
}
.image_box img {
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  transition: all 0.6s linear;
}
.main {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
}
.title {
  width: 100%;
  height: 26px;
  line-height: 26px;
  padding: 30px 0;
}
.title_li {
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}
.title_lis {
  width: 100%;
  height: 100%;
  font-size: 18px;
}
.no {
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  padding: 0 8px 0 0;
  font-weight: bold;
}
.th {
  height: 26px;
  text-decoration: none;
  outline: none;
  color: #3e3a39;
  font-weight: bold;
  padding: 0 0 0 8px;
}
.content {
  width: 100%;
  height: 886px;
}
.content_box {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 472px;
  padding: 0 0 100px 0;
}
.wrap_top {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 0;
  font-size: 16px;
  height: auto;
  word-wrap: break-word;

  div {
    margin-bottom: 15px;
  }
}

.map-frame {
  width: 100%;
  height: 400px;
  border: none;
  border-radius: 8px;
  margin-top: 30px;
  margin-bottom: 60px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 0 0 60px 0;
}

.wrap_bot {
  margin-top: 40px;
}
.top_t {
  font-size: 24px;
  padding: 0;
  margin: 0px 0 10px 0;
  font-weight: bold;
}
.off {
  padding-top: 90px;
  padding-bottom: 60px;
  border-top: 2px solid #b9bab9;
}
.off_title {
  text-align: center;
  height: 26px;
  font-size: 24px;
  line-height: 26px;
  color: #004080;
  font-weight: bold;
}
.off_list {
  margin-top: 80px;
  display: flex;
  height: 56px;
  justify-content: center;
}
ul {
  margin: 0;
}
li {
  position: relative;
  cursor: pointer;
}
.display_img {
  opacity: 0.3;
  padding-right: 20px;
}
.replacement_img {
  padding-right: 20px;
}
.qr-code {
  width: 140px;
  height: 170px;
  display: none; /* 初始状态隐藏 */
  position: absolute; /* 绝对定位 */
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  top: -190px;
  left: -40px; /* 调整位置 */
}
.qr-code img {
  padding: 10px;
  padding-bottom: 0px;
}
.qr_text {
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #3e3a39;
  line-height: 16px;
  height: 20px;
  text-align: center;
}
.inverted-triangle {
  position: absolute;
  left: 40%;
  bottom: -10%;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-top: 20px solid #fff;
}
li:hover .qr-code {
  display: block; /* 鼠标移入时显示 */
}
.contact-container {
  display: flex;
  gap: 40px;
  padding: 40px 0;
  max-width: 1200px;
  margin: 0 auto;
}

.message-section {
  flex: 1;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
  }

  .message-intro {
    color: #666;
    margin-bottom: 30px;
    line-height: 1.6;
  }
}

.contact-form {
  .el-form-item {
    margin-bottom: 20px;
  }

  .submit-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
  }
}

.contact-info {
  flex: 1;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 30px;
  }

  .info-list {
    margin-bottom: 30px;
  }

  .info-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
    color: #666;

    i {
      margin-right: 10px;
      font-size: 20px;
      color: #004080;
    }
  }
}

.map-frame {
  width: 100%;
  height: 300px;
  border: none;
  border-radius: 8px;
  margin-top: 20px;
}
.company-switch {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;

  span {
    cursor: pointer;
    padding: 8px 16px;
    font-size: 18px;
    color: #666;
    position: relative;
    transition: all 0.3s ease;

    &.active {
      color: #004080;
      font-weight: 500;

      &:after {
        content: "";
        position: absolute;
        bottom: -12px;
        left: 0;
        width: 100%;
        height: 2px;
        background: #004080;
      }
    }

    &:hover {
      color: #004080;
    }
  }
}

.company-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
